/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.isSamsungBrowser = window.navigator.userAgent.includes("SamsungBrowser");
      if (!this.isSamsungBrowser) {
        //The Samsung Internet browser already has its own back to top button that can't be disabled through CSS/JS, so only show our BTT btn if not using that browser
        this.style.display = "flex";
      }
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.checkVisible.bind(this));
    }

    checkVisible(event) {
      if (!this.isSamsungBrowser) {
        window.requestAnimationFrame(() => {
          let y = window.scrollY;
          if (y > this.pageHeight) {
            this.classList.add('back-to-top--active');
          } else {
            this.classList.remove('back-to-top--active');
          }
        });
      }
    }

    onClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
  customElements.define('back-to-top', BackToTop);
}